import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import Link from '../routing/Link';

class Terms extends Component {
  render() {
    return (
      <DocumentMeta title="Vilkår for brugen af SparPenge.dk" extend>
        <h3>Vilkår for brugen af SparPenge.dk</h3>
        <p>
          SparPenge.dk (herefter også kaldet "servicen") stilles gratis til
          rådighed for dets brugere, under forudsætning af at "Vilkår for brugen
          af SparPenge.dk" (herefter også kaldet "vilkårene") overholdes. Det
          påhviler den enkelte bruger at holde sig orienteret om eventuelle
          ændringer i vilkårene.
        </p>
        <p>
          Servicen stilles udelukkende til rådighed for brugerens personlige
          anvendelse, og må således ikke benyttes til andre formål uden
          forudgående skriftlig aftale.
        </p>

        <h5>Personlig brugerkonto</h5>
        <p>
          For at få fuldt udbytte af servicen kræves oprettelse af en gratis
          brugerkonto på SparPenge.dk. Denne brugerkonto og de oplysninger som
          der gives adgang til, stilles gratis til rådighed for brugerens
          personlige brug - der er således tale om en strengt personlig adgang
          til servicen.
        </p>
        <p>
          De oplysninger som afgives i forbindelse med oprettelse af en gratis
          brugerkonto, skal være ægte og tilhøre vedkommende, som opretter
          brugerkontoen. Hvis brugeren opretter sin brugerkonto via en Facebook
          konto, skal denne konto tilhøre brugeren selv. Ved oprettelse af
          brugerkonto tilknyttet en e-mail-adresse, skal denne være kontrolleret
          af brugeren - det er således ikke tilladt at benytte en e-mail-adresse
          fra en service, der tilbyder e-mail uden registrering. Afgivelse af
          falske oplysninger er ligeledes i strid med vilkårene.
        </p>
        <p>
          Det er ikke tilladt at dele, udlåne, videresælge eller på anden måde
          videregive oplysninger om sin brugerkonto, der kan give andre adgang
          til servicen. Det er ikke tilladt at benytte en brugerkonto til
          automatisk eller maskinelt at tilgå oplysninger på SparPenge.dk -
          automatisk og maskinel adgang til data tilbydes mod betaling og på
          licens fra U.C. UserConsumer Marketing Ltd.
        </p>

        <h5>Links</h5>
        <p>
          Servicen har ikke ansvar for indhold eller nogen form for kode på
          tredjeparts sider, der linkes til.
        </p>

        <h5>Indtjening</h5>
        <p>
          Servicen er en kommerciel tjeneste med indtjening fra annoncering og
          henvisningsprovision fra udbydere af produkter og ydelser, der
          henvises til fra servicen.
        </p>

        <h5>Persondatapolitik</h5>
        <p>
          Se vores <Link to="/privacy">Cookie- og privatlivspolitik</Link>.
        </p>
        <p>
          Hvis du ønsker yderligere oplysninger eller har spørgsmål til vores
          politik for personlige oplysninger, kan du kontakte os via
          oplysningerne på vores <Link to="/kontakt">kontaktside</Link>.
        </p>

        <h5>Cookies og Web Beacons</h5>
        <p>
          Se vores <Link to="/privacy">Cookie- og privatlivspolitik</Link>.
        </p>
      </DocumentMeta>
    );
  }
}

export default Terms;
